import { render } from "./FactureAchatModal.vue?vue&type=template&id=6cc3f1b6&scoped=true"
import script from "./FactureAchatModal.vue?vue&type=script&lang=js"
export * from "./FactureAchatModal.vue?vue&type=script&lang=js"

import "./FactureAchatModal.vue?vue&type=style&index=0&id=6cc3f1b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cc3f1b6"]])

export default __exports__